'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import env from 'config/env';
import { IEnvironment } from 'model/env';
import { discardNoiseFromLogs } from 'utils/analytics/helpers';

let isDatadogInitialized = false;

const initDatadog = (dataDogEnv: IEnvironment['DATADOG']) => {
  if (typeof window === 'undefined' || !dataDogEnv || isDatadogInitialized) {
    return;
  }

  datadogRum.init({
    applicationId: dataDogEnv.APPLICATION_ID,
    clientToken: dataDogEnv.CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: dataDogEnv.SERVICE_NAME,
    env: dataDogEnv.VIRTUAL_ENV, // This is used to identify virtual env
    version: env.VERSION, // must match the source map release-version uploaded in CI
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
  });

  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: dataDogEnv.CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: dataDogEnv.SERVICE_NAME,
    forwardErrorsToLogs: true,
    env: dataDogEnv.VIRTUAL_ENV,
    sessionSampleRate: 100,
    version: env.VERSION, // must match the source map release-version uploaded in CI
    beforeSend: discardNoiseFromLogs,
  });
  datadogLogs.logger.setLevel('info');
  datadogLogs.logger.setHandler(['http', 'console']);
  isDatadogInitialized = true;
};
export default initDatadog;
